export const NAME_MAX_LENGTH = 100;
export const DESCRIPTION_MAX_LENGTH = 256;
export const MAX_PRICE_VALUE = 1000000000;
export const MAX_WEIGHT_VALUE = 1000000000;
export const MAX_NUMBER_VALUE = 1000000000;
